(() => {
  const FLAGSHIP_HANDLES = new Set([
    'goy-brain-tee',
    'born-2-be-a-goy-tee',
    'free-your-mind-tee',
    'my-government-promised-me-more-tee',
    'do-goyim-really-tee',
    'goyim-lives-matter-tee',
    'classic-unisex-crewneck-t-shirt-gildan®-64000',
    'certified-truth-bomber'
  ]);
  const NEW_FREE_HANDLES = new Set(['do-goyim-really-tee', 'goyim-lives-matter-tee', 'classic-unisex-crewneck-t-shirt-gildan®-64000', 'certified-truth-bomber']);
  const LEGACY_VALIDATION_HANDLE = 'goy-brain-tee';

  const escapeHtml = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const init = () => {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.freeTeePickerReady === 'true') return;

      const sourceModal = form.querySelector('[data-bundle-modal]');
      if (!sourceModal || typeof HTMLDialogElement === 'undefined') return;

      const freeCards = [...sourceModal.querySelectorAll('[data-modal-product]')]
        .filter((card) => card.dataset.modalFreeEligible === 'true' && FLAGSHIP_HANDLES.has(card.dataset.modalProduct || ''));

      if (!freeCards.length) return;
      form.dataset.freeTeePickerReady = 'true';

      const modal = document.createElement('dialog');
      modal.className = 'bundle-modal bundle-modal--free-picker';
      modal.setAttribute('data-free-tee-modal', '');
      modal.innerHTML = `
        <div class="bundle-modal__head">
          <h2>Choose your free tee</h2>
          <button type="button" data-free-tee-close aria-label="Close">×</button>
        </div>
        <div class="bundle-modal__list" data-free-tee-list></div>
      `;

      const list = modal.querySelector('[data-free-tee-list]');
      freeCards.forEach((card) => list.appendChild(card.cloneNode(true)));
      sourceModal.insertAdjacentElement('afterend', modal);

      let activeButton = null;

      const cards = () => [...modal.querySelectorAll('[data-modal-product]')];
      const variantsFor = (card) => {
        try { return JSON.parse(card.querySelector('[data-modal-variants]')?.textContent || '[]'); }
        catch (error) { console.error('Free tee variants could not be parsed', error); return []; }
      };

      const groupsFor = (card) => [...card.querySelectorAll('[data-modal-option-dropdown]')];
      const closeMenus = (except = null) => {
        modal.querySelectorAll('[data-modal-option-dropdown]').forEach((group) => {
          if (group === except) return;
          const menu = group.querySelector('[data-modal-option-menu]');
          const trigger = group.querySelector('[data-modal-option-trigger]');
          if (menu) menu.hidden = true;
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      };

      const updateGroup = (group, value) => {
        group.dataset.freeSelectedValue = value || '';
        const label = group.querySelector('[data-modal-trigger-label]');
        if (label) label.textContent = value || '';
        const selectedButton = [...group.querySelectorAll('[data-modal-option-value]')].find((button) => button.dataset.modalOptionValue === value);
        const triggerSwatch = group.querySelector('[data-modal-trigger-swatch]');
        const optionSwatch = selectedButton?.querySelector('i');
        if (triggerSwatch && optionSwatch) triggerSwatch.style.cssText = optionSwatch.style.cssText;
        group.querySelectorAll('[data-modal-option-value]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.modalOptionValue === value)));
      };

      const applyVariant = (card, variant) => {
        if (!variant) return;
        card.dataset.modalSelectedVariant = String(variant.id);
        groupsFor(card).forEach((group, index) => updateGroup(group, variant.options?.[index] || ''));
        const image = card.querySelector('[data-modal-image]');
        if (image && variant.image) {
          image.src = variant.image;
          image.alt = `${card.querySelector('h3')?.textContent?.trim() || 'Free tee'} — ${variant.title || ''}`;
        }
        const price = card.querySelector('[data-modal-price]');
        if (price) price.textContent = variant.price || '';
        const choose = card.querySelector('[data-modal-choose]');
        if (choose) {
          choose.disabled = !variant.available;
          choose.textContent = variant.available ? 'Choose free tee' : 'Unavailable';
        }
      };

      const selectedVariant = (card) => {
        const variants = variantsFor(card);
        return variants.find((variant) => String(variant.id) === String(card.dataset.modalSelectedVariant))
          || variants.find((variant) => variant.available)
          || variants[0]
          || null;
      };

      const resolveAfterOptionChange = (card, changedIndex, changedValue) => {
        const variants = variantsFor(card);
        if (!variants.length) return null;
        const wanted = groupsFor(card).map((group, index) => (
          index === changedIndex ? changedValue : (group.dataset.freeSelectedValue || group.querySelector('[data-modal-trigger-label]')?.textContent?.trim() || '')
        ));
        const exact = variants.find((variant) => variant.options?.every((value, index) => value === wanted[index]) && variant.available)
          || variants.find((variant) => variant.options?.every((value, index) => value === wanted[index]));
        if (exact) return exact;
        return variants.find((variant) => variant.available && variant.options?.[changedIndex] === changedValue)
          || variants.find((variant) => variant.available)
          || variants[0]
          || null;
      };

      const refreshExistingTotals = () => {
        const checked = form.querySelector('[data-option-index] input:checked');
        if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const renderSelection = (button, card, variant) => {
        const handle = card.dataset.modalProduct || '';
        if (!FLAGSHIP_HANDLES.has(handle) || !variant?.available) return;
        const title = card.querySelector('h3')?.textContent?.trim() || 'Free tee';
        const image = variant.image || card.querySelector('[data-modal-image]')?.src || '';
        const variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        button.dataset.actualProductHandle = handle;
        button.dataset.productHandle = NEW_FREE_HANDLES.has(handle) ? LEGACY_VALIDATION_HANDLE : handle;
        button.dataset.variantId = String(variant.id);
        button.dataset.priceCents = String(variant.priceCents || 0);
        button.dataset.bundleRole = 'free';
        button.classList.add('is-filled');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = `
          <span class="bundle-add-row__selected">
            ${image ? `<img src="${escapeHtml(image)}" alt="">` : ''}
            <span><b>${escapeHtml(title)}</b>${variantTitle ? `<small>${escapeHtml(variantTitle)}</small>` : ''}</span>
          </span>
          <span class="bundle-add-row__edit">Edit</span>
        `;
        refreshExistingTotals();
      };

      const openFreePicker = (button) => {
        if (!button || !modal.showModal) return;
        activeButton = button;
        button.setAttribute('aria-expanded', 'true');
        const selectedHandle = button.dataset.actualProductHandle || button.dataset.productHandle || '';
        cards().forEach((card) => {
          const variants = variantsFor(card);
          let variant = null;
          if (selectedHandle === card.dataset.modalProduct && button.dataset.variantId) {
            variant = variants.find((entry) => String(entry.id) === String(button.dataset.variantId)) || null;
          }
          applyVariant(card, variant || variants.find((entry) => entry.available) || variants[0]);
        });
        closeMenus();
        modal.showModal();
      };

      const closeFreePicker = () => { if (modal.open) modal.close(); };
      const selectedFourOffer = () => {
        const offer = form.querySelector('[data-offer].is-selected');
        return Number(offer?.dataset.offerQuantity || 0) === 4 ? offer : null;
      };
      const invalidOrMissingFreeChoice = () => {
        const offer = selectedFourOffer();
        if (!offer) return null;
        const freeButton = offer.querySelector('[data-bundle-role="free"]');
        if (!freeButton) return null;
        const actualHandle = freeButton.dataset.actualProductHandle || freeButton.dataset.productHandle || '';
        const valid = freeButton.classList.contains('is-filled') && Boolean(freeButton.dataset.variantId) && FLAGSHIP_HANDLES.has(actualHandle);
        return valid ? null : freeButton;
      };

      modal.querySelector('[data-free-tee-close]')?.addEventListener('click', closeFreePicker);
      modal.addEventListener('close', () => {
        closeMenus();
        if (activeButton) activeButton.setAttribute('aria-expanded', 'false');
        activeButton = null;
      });
      modal.addEventListener('click', (event) => {
        if (event.target === modal) { closeFreePicker(); return; }
        const trigger = event.target.closest('[data-modal-option-trigger]');
        if (trigger && modal.contains(trigger)) {
          const group = trigger.closest('[data-modal-option-dropdown]');
          const menu = group?.querySelector('[data-modal-option-menu]');
          if (!group || !menu) return;
          const opening = menu.hidden;
          closeMenus(group);
          menu.hidden = !opening;
          trigger.setAttribute('aria-expanded', String(opening));
          return;
        }
        const optionButton = event.target.closest('[data-modal-option-value]');
        if (optionButton && modal.contains(optionButton)) {
          const group = optionButton.closest('[data-modal-option-dropdown]');
          const card = optionButton.closest('[data-modal-product]');
          if (!group || !card) return;
          const index = Number(group.dataset.modalOptionIndex || 0);
          const variant = resolveAfterOptionChange(card, index, optionButton.dataset.modalOptionValue || '');
          applyVariant(card, variant);
          closeMenus();
          return;
        }
        const choose = event.target.closest('[data-modal-choose]');
        if (choose && modal.contains(choose)) {
          const card = choose.closest('[data-modal-product]');
          const variant = card ? selectedVariant(card) : null;
          if (!card || !variant || !activeButton) return;
          renderSelection(activeButton, card, variant);
          closeFreePicker();
          return;
        }
        if (!event.target.closest('[data-modal-option-dropdown]')) closeMenus();
      });

      document.addEventListener('click', (event) => {
        const freeButton = event.target.closest('[data-bundle-plus][data-bundle-role="free"]');
        if (freeButton && form.contains(freeButton)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openFreePicker(freeButton);
          return;
        }
        const buyNow = event.target.closest('[data-buy-now]');
        if (buyNow && form.contains(buyNow)) {
          const missingFree = invalidOrMissingFreeChoice();
          if (missingFree) {
            event.preventDefault();
            event.stopImmediatePropagation();
            openFreePicker(missingFree);
          }
        }
      }, true);

      form.addEventListener('submit', (event) => {
        const missingFree = invalidOrMissingFreeChoice();
        if (!missingFree) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openFreePicker(missingFree);
      }, true);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
